import CashierActionType from './cashierActionType';

export const getCashierSettings = (brandId) => ({
  type: CashierActionType.GET_CASHIER_SETTINGS,
  payload: { brandId },
});

export const saveCashierGeneralSettings = (data) => ({
  type: CashierActionType.SAVE_CASHIER_GENERAL_SETTINGS,
  payload: { data },
});

export const resetCashierGeneralSettings = () => ({
  type: CashierActionType.RESET_CASHIER_GENERAL_SETTINGS,
});

export const saveCashierBrandSettings = (data) => ({
  type: CashierActionType.SAVE_CASHIER_BRAND_SETTINGS,
  payload: { data },
});

export const resetCashierBrandSettings = () => ({
  type: CashierActionType.RESET_CASHIER_BRAND_SETTINGS,
});

export const editCashierGeneralSettings = (brandId, data) => ({
  type: CashierActionType.EDIT_CASHIER_GENERAL_SETTINGS,
  payload: { brandId, data },
});
